import React from "react"
import { FormSectionElements } from "../../entities/formTemplateDataType";
import FormValidationUtils from "../../utilities/FormValidationUtils";


interface Props {
    bodyMsg: string;
    title: string;
    isEng: boolean;
    Visible: boolean;
    dismissible?: boolean; 
    field?: FormSectionElements;
}

interface State {
    dismissed: boolean;
}

export class ErrorAlertComponent extends React.Component<Props, State> {
    dateTypeFieldList = [];
    constructor(props: Props) {
        super(props);

        this.state = {
            dismissed: false,
        }
      
        if (this.props.field)
            FormValidationUtils.runJavascript(this.props.field);
    }

    generateHtmlString = () => {
        const field = this.props.field;
        if (field) {
            FormValidationUtils.runJavascript(field);
        }
        
        let html = [];
        let bodyMsg = this.props.bodyMsg;
        let title = this.props.title;

        if (field?.Visible && !this.state.dismissed) {
            html.push(
                <div className="ontario-alert ontario-alert--error callout-max-width">
                    <div className="ontario-alert__header">
                        <div className="ontario-alert__header-icon">
                            <svg className="ontario-icon" aria-hidden="true" focusable="false" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                                <use href="#ontario-icon-alert-error"></use>
                            </svg>
                        </div>
                        <h2 className="ontario-alert__header-title ontario-h4">{title}</h2>
                        {this.props.dismissible && <button style={{marginLeft: "auto", background: "none", border: "none", cursor: "pointer"}} onClick={() => this.setState({dismissed: true})}>
                            <svg className="ontario-icon" style={{fill: "#1A1A1A"}} aria-hidden="true" focusable="false" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                                <use href="#ontario-icon-close"></use>
                            </svg>
                        </button>}
                    </div>
                    <div className="ontario-alert__body">
                        <p>{bodyMsg}</p>
                    </div>
                </div>
            );
        }

        return html;
    }

    render() {
        return (
            this.generateHtmlString()
        )
    }
}
